import {
    CREATETEAM_FAIL,
    CREATETEAM_SUCCESS,
} from "../actionTypes";

const initialState = {
    user: null,
};

const createTeamReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATETEAM_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload,
            };
        case CREATETEAM_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default createTeamReducer;
